/* @flow */
import React from 'react';
import AddButton from 'components/AddButton.jsx';
import AddParentChildModal from './AddParentChildModal.jsx';
import Fieldset from 'components/Fieldset.jsx';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Legend from 'components/Legend.jsx';
import minimalRelatedUserFragment from 'user/fragments/minimalRelatedUserFragment.gql';
import { mountModal } from 'lib/modal';
import UserParentChildRow from 'settings/components/UserParentChildRow.jsx';

import 'settings/components/styles/UserParentChildSection.scss';

type MinimalRelatedUser = {
  id: number,
}

type Props = {
  viewingUserId: ?number,
  relation: 'parent' | 'child',
  relatedUsers: [MinimalRelatedUser],
  pendingRelatedUsers: [MinimalRelatedUser],
  permissions: Object,
  data: Object,
};

class UserParentChildSection extends React.Component {
  props: Props;
  state = {};

  addParentChild = () => {
    mountModal(
      <AddParentChildModal
        viewingUserId={this.props.viewingUserId}
        relation={this.props.relation}
        title={this.getAddText()}
        onRequestHide={() => {}}
        onAddRelation={() => this.props.data.refetch()}
      />,
      this
    );
  }

  getAddText() {
    return this.props.relation === 'parent' ? 'Add your parent' : 'Add your child';
  }

  renderAddButton() {
    const { relation, permissions } = this.props;
    if ((relation === 'parent' && permissions.can_add_parent) ||
        (relation === 'child' && permissions.can_add_child)) {
      return (
        <AddButton
          className="UserParentChildSection-add-button"
          onClick={this.addParentChild}
          size="large">
          {this.getAddText()}
        </AddButton>
      );
    }
    return null;
  }

  render = () => {
    const titleText = this.props.relation === 'parent' ? 'Parents' : 'Children';
    return (
      <Fieldset>
        <Legend>{titleText}</Legend>
        <table className="UserParentChildSection-table">
          <tbody>
            {this.props.relatedUsers.map(u =>
              <UserParentChildRow
                key={u.id}
                relation={this.props.relation}
                related_user={u}
              />
            )}
            {this.props.pendingRelatedUsers.map(u =>
              <UserParentChildRow
                key={u.id}
                relation={this.props.relation}
                related_user={u}
                pending
              />
            )}
          </tbody>
        </table>
        {this.renderAddButton()}
      </Fieldset>
    );
  }
}

const withPermissions = graphql(gql`
  query {
    me {
      id
      permissions {
        can_add_parent
        can_add_child
      }
      family {
        children {
          ...minimalRelatedUser
        }
        pending_children {
          ...minimalRelatedUser
        }
        parents {
          ...minimalRelatedUser
        }
        pending_parents {
          ...minimalRelatedUser
        }
      }
    }
  }
  ${minimalRelatedUserFragment}
  `,
  {
    props: ({ data, ownProps }) => {
      const familyKey = ownProps.relation === 'parent' ? 'parents' : 'children';
      const pendingFamilyKey = ownProps.relation === 'parent' ? 'pending_parents' : 'pending_children';

      return {
        data,
        viewingUserId: data.me ? data.me.id : undefined,
        permissions: data.me ? data.me.permissions : {},
        relatedUsers: data.me ? data.me.family[familyKey] : [],
        pendingRelatedUsers: data.me ? data.me.family[pendingFamilyKey] : [],
      };
    },
  }
);

export { UserParentChildSection };
export default withPermissions(UserParentChildSection);



// WEBPACK FOOTER //
// ./src/settings/components/UserParentChildSection.jsx